import { render } from "./CursorInfoWidget.vue?vue&type=template&id=389b934d"
import script from "./CursorInfoWidget.vue?vue&type=script&lang=js"
export * from "./CursorInfoWidget.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Dani\\Desktop\\[ PROFESIONAL ]\\WEB 2021 - CÓDIGO\\web2021\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__